
import hospital from "../../assets/hospital.png";
import hotel from "../../assets/hotel.png"
import employee from "../../assets/employee.png"
import drum from "../../assets/drum.png"
import bank from "../../assets/bank.png"
import weather from "../../assets/weather.png"
import currency from "../../assets/currency.png"
import feul from "../../assets/fuel.png"
import campus from '../../assets/CompusCareerHub.png'

const projects = [
  {
      name:"CampusCareeHub",
      description:"Played a pivotal role in developing and optimizing booking and customer models during the InfosysSpringboard Internship, driving the application’s success. Engineered efficient back-end solutions using Spring Boot and MySQL, improving operational accuracy",
      tags: [
        {
          name:"Java",
          color:"green",

        },
        {
          name:"Spring Boot",
          color:"orange",
        },
        {
          name:"ReactJs",
          color:"red",

        },
        {
          name:"mySql",
          color:"#32a897"
        },
        {
          name: "HTML",
          color: "blue",
        },
        {
          name: "CSS",
          color: "black",
        },
        {
          name: "JavaScript",
          color: "red",
        },
      ],
      image:campus ,
      source_code_link: "https://github.com/mantosh-mariner/campusCareer",
    },
    
  {
    
      name:"Fuel Agency Suite",
      description:"Played a pivotal role in developing and optimizing booking and customer models during the Infosys Springboard Internship, driving the application’s success.  Engineered efficient back-end solutions using Spring Boot and MySQL, improving operational accuracy and scalability by 25%",
      tags: [
        {
          name:"Java",
          color:"green",

        },
        {
          name:"Spring Boot",
          color:"orange",
        },
        {
          name:"ReactJs",
          color:"red",

        },
        {
          name:"mySql",
          color:"#32a897"
        },
        {
          name: "HTML",
          color: "blue",
        },
        {
          name: "CSS",
          color: "black",
        },
        {
          name: "JavaScript",
          color: "red",
        },
      ],
      image: feul,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },
    
    {
      name: "Hotel Web App",
      description:
        "Web-based platform that enables users to effortlessly search, book, and manage hotel accommodations, offering a seamless experience for travelers. The application integrates various features, including real-time availability, secure payment processing, and user-friendly management tools, ensuring a convenient and efficient solution for all lodging needs.",
      tags: [
        {
          name: "react",
          color: "red",
        },
        {
          name: "MySql",
          color: "green",
        },
        {
          name: "Boostrap",
          color: "gray",
        },
        {
          name: "Spring Boot",
          color: "royalblue",
        },
      ],
      image: hotel,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },
    {
      name: "Health Care Appointment System",
      description:
       "Web-based platform designed to streamline the process of booking and managing medical appointments, allowing patients to easily schedule visits with healthcare providers. The system features user-friendly interfaces for both patients and doctors, real-time availability checks, secure appointment confirmations, and automated reminders.",
      tags: [
        {
          name: "Java",
          color: "blue",
        },
        {
          name: "JSP, JavaScript",
          color: "green",
        },
        {
          name: "MySql",
          color: "red",
        },
      ],
      image: hospital,
      source_code_link: "https://github.com/",
    },
    {
      name: "Employee Management System",
      description:
        "Comprehensive web-based application that simplifies the management of employee records, including onboarding, performance tracking, and attendance monitoring. The system enables HR personnel to efficiently manage employee data, streamline communication, and facilitate performance evaluations,",
      tags: [
        {
          name: "Java",
          color: "blue",
        },
        {
          name: "MySql",
          color: "black",
        },
        {
          name: "Netbeans",
          color: "red",
        },
      ],
      image: employee,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },

    {
      name: "Banking Application",
      description:
        "Bank Management System: A comprehensive Java-based application that handles core banking functionalities, including customer account management and transaction tracking. Utilizes MySQL for robust data management.",
      tags: [
        {
          name: "Java",
          color: "blue",
        },
        {
          name: "MySql",
          color: "black",
        },
        {
          name: "Intellij idea",
          color: "red",
        },
      ],
      image: bank,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },
    

    {
      name: "Drum Kit",
      description:
        "A Drum Kit Project showcases an interactive virtual drum set built with HTML, CSS, and JavaScript. Users can click or press keys to play different drum sounds, demonstrating real-time audio response. It highlights skills in web development, including DOM manipulation and event handling.",
      tags: [
        {
          name: "HTML",
          color: "blue",
        },
        {
          name: "CSS",
          color: "black",
        },
        {
          name: "JavaScript",
          color: "red",
        },
      ],
      image: drum,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },
    {
      name: "Weather App",
      description:
        "A responsive weather app built with HTML, CSS, and JavaScript, providing real-time weather updates with a clean, user-friendly interface. Easily access current conditions and forecasts for any location..",
      tags: [
        {
          name: "HTML",
          color: "blue",
        },
        {
          name: "CSS",
          color: "black",
        },
        {
          name: "JavaScript",
          color: "red",
        },
      ],
      image: weather,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },

    {
      name: "Currency Convertor",
      description:
        "A sleek currency converter built with HTML, CSS, and JavaScript, allowing users to quickly convert between different currencies with real-time exchange rates. Simple, intuitive, and efficient for daily currency conversions.",
      tags: [
        {
          name: "HTML",
          color: "blue",
        },
        {
          name: "CSS",
          color: "black",
        },
        {
          name: "JavaScript",
          color: "red",
        },
      ],
      image: currency,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },

    {
      name:"Fuel Agency Suite",
      description:"Played a pivotal role in developing and optimizing booking and customer models during the Infosys Springboard Internship, driving the application’s success. <br/>  Engineered efficient back-end solutions using Spring Boot and MySQL, improving operational accuracy and scalability by 25%",
      tags: [
        {
          name:"Java",
          color:"green",

        },
        {
          name:"Spring Boot",
          color:"orange",
        },
        {
          name:"ReactJs",
          color:"red",

        },
        {
          name:"mySql",
          color:"#32a897"
        },
        {
          name: "HTML",
          color: "blue",
        },
        {
          name: "CSS",
          color: "black",
        },
        {
          name: "JavaScript",
          color: "red",
        },
      ],
      image: feul,
      source_code_link: "https://github.com/mantosh-mariner?tab=repositories",
    },
    
    
  ];
  
  export { projects };
  